import { Component, ElementRef, ViewChild } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-jcc',
  templateUrl: './jcc.component.html',
  styleUrls: ['./jcc.component.scss'],
})
export class JccComponent {
  @ViewChild('jccPaymentsForm') jccPaymentsForm: ElementRef;
  paymentData: any;
  jccServerLink: string;

  submitForm(paymentData: any) {
    this.paymentData = paymentData;
    this.jccServerLink =
      environment.name === 'production'
        ? 'https://jccpg.jccsecure.com/EcomPayment/RedirectAuthLink'
        : 'https://tjccpg.jccsecure.com/EcomPayment/RedirectAuthLink';
    setTimeout((_) => this.jccPaymentsForm.nativeElement?.submit(), 10);
  }
}
